import styles from "./index.module.scss";

export const SettingsEmptyState = ({ text }) => {
  return (
    <div className={styles.settings_empty_state_wrapper}>
      <div className={styles.settings_empty_state}>{text}</div>
    </div>
  );
};
